<style scoped>

</style>
<template>
  <div>
    <Modal
      v-model="showModal"
      :closable="false"
      :mask-closable="false"
      :title="modalTitle"
    >
      <Form
        ref="form"
        :model="formData"
        :label-width="150"
      >
        <FormItem
          prop="company_id"
          label="公司"
          :rules="{ type:'number', required: true, message: '公司必选', trigger: 'blur'}"
        >
          <Select
            v-model="formData.company_id"
            placeholder="请选择公司"
            style="width: 100%"
            @on-change="selectCompany"
          >
            <Option
              v-for="company in filter_companies"
              :key="company.id"
              :value="company.id"
            >
              {{ company.short_name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem
          prop="credit_code"
          label="统一社会信用编码"
          :rules="{required: true, message: '统一社会信用编码必填', trigger: 'blur'}"
        >
          <Input
            v-model="formData.credit_code"
            placeholder="请填写统一社会信用编码"
          />
        </FormItem>
        <FormItem
          prop="set_up_at"
          label="成立时间"
          :rules="{required: true, message: '成立时间必选', trigger: 'blur'}"
        >
          <DatePicker
            :value="formData.set_up_at"
            type="date"
            placeholder="请选择成立时间"
            @on-change="dateChange"
          />
        </FormItem>
        <FormItem 
          prop="remark"
          label="备注"
        >
          <Input
            v-model="formData.remark"
            type="textarea"
            placeholder="请输入备注"
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button
          @click="cancel"
        >
          取消
        </Button>
        <Button
          type="primary"
          :loading="saveLoading"
          @click="ok"
        >
          确定
        </Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  export default {
    props: {
      display: {
        type: Number,
        default:() => 0
      },
      formProps: {
        type:Object,
        default:() => ({})
      },
      list:{
        type:Array,
        default:() => ([])
      },
      saveLoading:{
        type:Boolean,
        default:() => false
      }
    },
    data() {
      return {
        formData: {
          remark:null,
          company_id: null,
          company_name: null,
          credit_code: null,
          set_up_at: null,
          id: null
        },
        modalTitle:'',
        showModal: false
      }
    },
    computed: {
      ...mapGetters({
        companies: 'async/companies',
      }),
      filter_companies() {
        if (!this.display) { return [] }
        const company_id_hash = this.list.reduce((total, item) => {
          total[item.company_id] = true
          return total
        }, {})
        if (this.formProps) {
          company_id_hash[this.formProps.company_id] = false
        }
        return this.companies.filter((item => !company_id_hash[item.id]))
      }
    },
    watch: {
      display(value) {
        if (value === 1) {
          this.modalTitle = '新增'
          Object.keys(this.formData).forEach(key => {
            this.formData[key] = null
          })
        }
        if (value === 2) {
          this.modalTitle = '编辑'
          Object.keys(this.formData).forEach(key => {
            this.formData[key] = this.formProps[key]
          })
        }
        if (value === 0) {
          this.showModal = false
          this.$refs.form.resetFields() // 清理form表单
        } else {
          this.showModal = true
        }
      },
    },
    methods: {
      selectCompany(data) {
        const select_company = this.filter_companies.filter(item => item.id === data)[0] || {}
        this.formData.company_id = data
        this.formData.company_name = select_company.short_name
      },
      ok() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$emit('ok', {...this.formData, call:() => {
              this.$Message.success({
                duration:0.7,
                content:this.formData.id === null ? '新增成功！' : '修改成功'
              })
              this.cancel()
            }}) 
          }
        })
      },
      cancel() {
        this.$emit('cancel')
      },
      dateChange(value) {
        this.formData.set_up_at = value
      }
    }
  }
</script>
